<template>
  <div
    class="unorganized_container"
    :style="{ background: !sourceShow ? '#ffffff00' : '#000000bf' }"
  >
    <div
      :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }"
    >
      <img :src="getContainerBG" v-if="backgroundMask" />
    </div>
    <div class="overal_bg" v-if="curBG == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBGVal == 'typeStrong'"></div>
    <unorganizedScience v-if="refreshTag" ref="science"></unorganizedScience>
    <left-part
      :modelType="modelType"
      ref="leftPart"
      v-if="
        !isSetting &&
        refreshTag &&
        $store.state.customerId != '120' &&
        $store.state.customerId != '20'
      "
    ></left-part>
    <right-part
      :modelType="modelType"
      ref="rightPart"
      v-if="!isSetting && refreshTag"
    ></right-part>
    <setting :modelType="modelType" v-if="isSetting"></setting>

    <div class="unorganized-bg"></div>

    <keep-alive>
      <emission-source
        v-if="refreshTag"
        ref="emission"
        :style="{
          display: sourceShow && sourceShow == 'emission' ? 'block' : 'none',
        }"
      />
    </keep-alive>
    <material-bar v-if="refreshTag"></material-bar>

    <shed-bar v-if="materialShow && refreshTag" :newshed="'焦炭大棚'"></shed-bar>
    <new-shed v-if="vdmShow && refreshTag && $store.state.customerId != '39'"></new-shed>
    <new-shed-forth
      v-if="$store.state.customerId == '39' && ($store.state.showShed || isShowForthShed)"
    ></new-shed-forth>
    <device-bar v-if="deviceShow && refreshTag"></device-bar>
    <div v-show="showKeyDialog" class="KeyPointDialog">
      <div class="title">
        <p>
          <span class="chartTitle">污染治理同步率</span>
          <span class="rate">{{ syncRate }}%</span>
        </p>
      </div>
      <div class="chart" ref="chart"></div>
      <p class="title">
        <span class="chartTitle">改进建议：{{ recommendation }}</span>
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftPart from "@/modules/DIYcomponents/leftPart.vue";
import rightPart from "@/modules/DIYcomponents/rightPart.vue";
import setting from "@/modules/DIYcomponents/setting.vue";
import unorganizedScience from "@/modules/unorganizedComponents/unorganizedScience/index.vue";
import deviceBar from "@/modules/unorganizedComponents/deviceBar/index.vue";
import materialBar from "@/modules/unorganizedComponents/materialBar/index.vue";
import shedBar from "@/modules/unorganizedComponents/shedBar/index.vue";
import vdmBar from "@/modules/unorganizedComponents/vdmBar/index.vue";
import newShed from "@/modules/unorganizedComponents/newShed/index.vue";
import newShedVdmCopy from "@/modules/unorganizedComponents/newShed/newShedVdmCopy.vue";
// import newShedThird from "@/modules/unorganizedComponents/newShed/newShedThird.vue";
import newShedForth from "@/modules/unorganizedComponents/newShed/newShedForth.vue";

import emissionSource from "@/modules/unorganizedComponents/emission/EmissionSource.vue";
import materialSource from "@/modules/unorganizedComponents/emission/MaterialSource.vue";
//import materialSource from "@/views/UnorganizedMod/components/MaterialSource.vue";
import { mapState } from "vuex";

import { unorganizedLightWallRender } from "@/assets/js/lightWall/unorganized_science.js";
import { dutyLightWallRender } from "@/assets/js/lightWall/duty_science.js";

import { ref, shallowRef, computed, provide } from "vue";

import { CamLeapFunc } from "@/assets/js/unity3D/index.js";
import getOpt from "./chartOptTrend.js";
import {dateFormat, unwarp} from "@/utils/tools.js";
import {getKeyMonitorList} from  '@/assets/js/unity3D/hualeUnorganized';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    leftPart,
    rightPart,
    setting,
    emissionSource,
    materialSource,
    unorganizedScience,
    deviceBar,
    materialBar,
    shedBar,
    vdmBar,
    newShed,
    newShedVdmCopy,
    // newShedThird,
    newShedForth,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      backgroundMask: bmeConfig.backgroundMask,
      customerId: this.$store.state.customerId,
      leftRightPart: false,
      isSetting: false,
      hash: false,
      modelType: "UnorganizedMod",
      sourceData: [],
      factoryArea: "",
      materialArea: "",
      vdmArea: "",
      vdmShow: "",
      shedShow: "",
      materialShow: "",
      branchFactoryList: [],
      materialShedList: [],
      sourceShow: false,
      branchFactoryId: "",
      pageNo: 1,
      pageSize: 100,
      inventoryId: "",
      deviceShow: false,
      emNameVal: "",
      inventorySwitch: false,
      emissionLoading: false,
      styleType: bmeConfig.styleType,
      styleTypeMap: styleTypeMap,
      curBG: "",
      refreshTag: true,
      total: "",
      scrollPage: 1,
      emissionSwitch: "",
      shedObj: {},
      inventoryName: "",
      emissionType: "",
      nameType: "",
      showKeyDialog: false,
      DialogLeft: "2022px",
      DialogTop: "400px",
      chart: null,
      syncRate: "0",
      recommendation: "",
      shedList: [],
    };
  },
  //计算属性
  computed: {
    isShowForthShed() {
      return window.bmeConfig.isShowForthShed;
    },
    DialogPosition() {
      return "left: " + this.DialogLeft + ";top: " + this.DialogTop + ";";
    },
    getContainerBG: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/MainMod/img/" + this.styleTypeMap[this.curBG].dutyBG);
      }
      if (!bmeConfig.backgroundMask) {
        imgSrc = "";
      }
      return imgSrc;
    },
    curBGVal: function () {
      return this.$store.state.curBG;
    },
  },
  provide: function () {
    return {
      getSourceData: computed(() => this.sourceData),
      updateSourceData: this.updateSourceData,

      getScrollPage: computed(() => this.scrollPage),
      updateScrollPage: this.updateScrollPage,

      getTotal: computed(() => this.total),
      updateTotal: this.updateTotal,

      getPageNo: computed(() => this.pageNo),
      updatePageNo: this.updatePageNo,

      getFactoryArea: computed(() => this.factoryArea),
      updateFactoryArea: this.updateFactoryArea,

      getMaterialArea: computed(() => this.materialArea),
      updateMaterialArea: this.updateMaterialArea,

      getVdmArea: computed(() => this.vdmArea),
      updateVdmArea: this.updateVdmArea,

      getBranchFactoryId: computed(() => this.branchFactoryId),
      updateBranchFactoryId: this.updateBranchFactoryId,

      getEmNameVal: computed(() => this.emNameVal),
      updateEmNameVal: this.updateEmNameVal,

      getBranchFactoryList: computed(() => this.branchFactoryList),
      updateBranchFactoryList: this.updateBranchFactoryList,

      getMaterialShedList: computed(() => this.materialShedList),
      updateMaterialShedList: this.updateMaterialShedList,

      getSoureceShow: computed(() => this.sourceShow),
      updateSourceShow: this.updateSourceShow,

      getLeftRightPart: computed(() => this.leftRightPart),
      updateLeftRightPart: this.updateLeftRightPart,

      getInventoryId: computed(() => this.inventoryId),
      updateInventoryId: this.updateInventoryId,

      getInventoryName: computed(() => this.inventoryName),
      updateInventoryName: this.updateInventoryName,

      getInventorySwitch: computed(() => this.inventorySwitch),
      updateInventorySwitch: this.updateInventorySwitch,

      getEmissionLoading: computed(() => this.emissionLoading),
      updateEmissionLoading: this.updateEmissionLoading,

      getShedObj: computed(() => this.shedObj),
      updateShedObj: this.updateShedObj,

      getShedList: computed(() => this.shedList),
      updateShedList: this.updateShedList,
      updateKeyPointInfoPosition: this.updateKeyPointInfoPosition,
    };
  },
  //监控data中的数据变化
  watch: {
    getShedObj: {
      handler(newVal) {
        this.showKeyDialog = true;
        console.log(112233)
      },
      deep: true
    },
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal;
      },
      deep: true,
    },
    leftRightPart: {
      handler(newVal, oldVal) {
        let valid = newVal;
        if (valid === true) {
          let this_ = this;
          setTimeout(function () {
            $(this_.$refs.leftPart.$el).removeClass("slider_in");

            $(this_.$refs.rightPart.$el).removeClass("slider_in");

            if (bmeConfig.rectType) {
              $(this_.$refs.emission.$el).addClass("left_slider_in_rectType");
            } else {
              $(this_.$refs.emission.$el).addClass("left_slider_in");
            }
          }, 50);
        } else {
          let this_ = this;
          setTimeout(function () {
            $(this_.$refs.leftPart.$el).addClass("slider_in");

            $(this_.$refs.rightPart.$el).addClass("slider_in");

            if (bmeConfig.rectType) {
              $(this_.$refs.emission.$el).removeClass("left_slider_in_rectType");
            } else {
              $(this_.$refs.emission.$el).removeClass("left_slider_in");
            }
          }, 50);
        }
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.hash.substr(1) == "setting") {
      this.hash = true;
    } else {
      this.hash = false;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    this.curBG = this.$store.state.curBG;

    //this.updateSourceData();

    this.updateMaterialShedList();

    this.updateBranchFactoryList();
    this.updateSourceData(
      this.branchFactoryId,
      this.pageNo,
      this.pageSize,
      "",
      "",
      "",
      "",
      ""
    );
    this.chart = echarts.init(this.$refs.chart);
  },
  errorCaptured(error,vm,info) {
    console.log('kk-',error,vm,info);
    let msg = '错误信息：' + error + '，错误详情：' + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  //方法集合
  methods: {
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat('YYYY-mm-dd HH:MM:SS',date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: 'notOpen',
        secondLevelCode: 'beforeError',
        additionalInfo: {
          source: 'screen',
          mac: '867788sjgdjbsd',
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance,
          sourcePage: instance,
          time: time,
          msg: msg
        }
      }
      this.$apiUtils.post(url,param).then(res => {

      }).catch(error => {

      });
    },
    updateInventoryName(val) {
      this.inventoryName = val;
    },
    updateShedObj(val,index) {
      console.log(val, "val",index);
      this.shedObj = "";
      this.$forceUpdate();
      this.shedObj = val;
      if (
        (this.$store.state.customerId == "38" &&
        this.$store.state.titleViews == "无组织") || this.$store.state.customerId == "42"
      ) {
        this.setShedRate(val);
      }
      if(this.$store.state.customerId == "59" &&
        this.$store.state.titleViews == "无组织") {
        let list = getKeyMonitorList();
        CamLeap(list[index].position);
      }
    },
    updateInventorySwitch(val) {
      this.inventorySwitch = val;
    },
    updateInventoryId(val) {
      let that = this;
      if (val) {
        this.deviceShow = true;
        this.$forceUpdate();
        this.$nextTick(function () {
          that.inventoryId = val;
        });
      } else {
        this.inventoryId = false;
        this.deviceShow = false;
      }
    },
    updateLeftRightPart(val) {
      this.leftRightPart = val;
    },
    updateEmissionLoading(val) {
      this.emissionLoading = val;
    },
    updateTotal(val) {
      this.total = val;
    },
    updatePageNo(val) {
      this.pageNo = val;
    },
    updateScrollPage(val) {
      this.scrollPage = val;
    },
    updateSourceData(
      branchFactoryId,
      pageNo,
      pageSize,
      process,
      emName,
      nameType,
      processSection,
      forceShow,
      cb
    ) {
      if (!cb) {
        this.pageNo = 1;
      }
      let that = this;
      this.nameType = nameType;
      let findInventoryListUrl = CONFIG.requestName + this.$apiOpt.findInventoryList;
      that.emissionType = nameType;
      this.$apiUtils
        .get(findInventoryListUrl, {
          customerId: this.$store.state.customerId,
          branchFactoryId: branchFactoryId ? branchFactoryId : "",
          process: process ? process : "",
          pageNo: pageNo ? pageNo : 1,
          pageSize: pageSize ? pageSize : 100,
          emName: emName ? emName : "",
          nameType: nameType ? nameType : "",
          processSection: processSection ? processSection : "",
        })
        .then(function (data) {
          that.total = data?.total ?? 0;

          if (forceShow) {
            //that.updateSourceShow(true);
          }

          //有回调的是下拉刷新，没有回调的是查询
          if (cb) {
            $.merge(that.sourceData, data.records);
            that.sourceData.forEach((item,index)=>{
              item.index = index;
            });
            //debugger;
            that.$forceUpdate();
            that.$nextTick(function () {
              cb(data.records, data.total);
            });
          } else {
            that.sourceData = data?.records;
            that.sourceData.forEach((item,index)=>{
              item.index = index;
            });
          }
        });
    },
    updateFactoryArea(val, emNameVal, forceShow, noUpdateSource) {
      this.updateSourceShow("emission");
      this.pageNo = 1;
      this.factoryArea = val;
      this.materialArea = "";
      this.vdmArea = "";
      this.emissionType = "";
      this.branchFactoryId = val;
      this.emNameVal = emNameVal;
      //this.updateSourceData(table3D_data);
      if (!noUpdateSource) {
        this.updateSourceData(
          this.branchFactoryId,
          this.pageNo,
          this.pageSize,
          "",
          this.emNameVal,
          this.nameType,
          this.emissionType,
          forceShow
        );
      }
    },
    updateMaterialArea(val) {
      let that = this;
      this.updateSourceShow("material");
      this.factoryArea = "";
      //this.materialArea = val;
      this.vdmArea = "";
      if (val) {
        this.materialShow = true;
        this.$forceUpdate();
        this.$nextTick(function () {
          that.materialArea = val;
        });
      } else {
        this.materialArea = false;
        this.materialShow = false;
      }
    },
    updateVdmArea(val) {
      let that = this;
      this.updateSourceShow("vdm");
      //this.vdmArea = val;
      this.factoryArea = "";
      this.materialArea = "";
      if (val) {
        this.vdmShow = true;
        this.$forceUpdate();
        this.$nextTick(function () {
          that.vdmArea = val;
        });
      } else {
        this.vdmArea = false;
        this.vdmShow = false;
      }
    },
    updateEmNameVal(val) {
      this.emNameVal = val;
    },
    updateBranchFactoryId(val) {
      this.branchFactoryId = val;
    },
    updateBranchFactoryList() {
      let that = this;
      let findRegionalRankingUrl = CONFIG.requestName + this.$apiOpt.findRegionalRanking;
      this.$apiUtils
        .get(findRegionalRankingUrl, {
          customerId: this.$store.state.customerId,
          type: "",
        })
        .then(function (data) {
          that.branchFactoryList = data;
        });
    },
    updateMaterialShedList() {
      let that = this;
      let findMaterialShedUrl = CONFIG.requestName + this.$apiOpt.findMaterialShed;
      this.$apiUtils
        .get(findMaterialShedUrl, {
          customerId: this.$store.state.customerId,
          type: "",
        })
        .then(function (data) {
          that.materialShedList = data;
        });
    },
    updateSourceShow(val) {
      if (val) {
        this.updateEmissionLoading(true);
        this.sourceShow = val;
        $(".unorganized-bg").show();
      } else {
        this.sourceShow = false;
        $(".unorganized-bg").hide();
      }

      if (val === true) {
        $(this.$refs.science.$el).fadeOut(1000);
      } else {
        $(this.$refs.science.$el).fadeIn(1000);
      }
    },
    updateKeyPointInfoPosition(position) {
      this.DialogLeft = position.left + "px";
      this.DialogTop = position.top + "px";
    },
    updateShedList(data) {
      this.shedList = data || [];
    },
    reset() {
      this.leftRightPart = false;
      this.modelType = "UnorganizedMod";
      this.sourceData = [];
      this.factoryArea = "";
      this.materialArea = "";
      this.vdmArea = "";
      this.branchFactoryList = [];
      this.materialShedList = [];
      this.sourceShow = false;
      this.branchFactoryId = "";
      this.pageNo = 1;
      this.pageSize = 100;
      this.inventoryId = "";
      this.inventorySwitch = false;
      this.emissionLoading = false;
      this.refreshTag = true;
      this.emissionType = "";
      this.shedList = [];
    },
    reload() {
      this.refreshTag = false;
      this.$nextTick(function () {
        this.reset();
        this.refreshTag = true;
        //this.updateSourceData();

        this.updateMaterialShedList();

        this.updateBranchFactoryList();
        //debugger;-
        this.updateSourceData(
          this.branchFactoryId,
          this.pageNo,
          this.pageSize,
          "",
          "",
          "",
          "",
          ""
        );
      });
    },
    setShedRate(shed) {
      let _this = this;
      this.pmData = {
        xData: [],
        y1Data: [],
      };
      let rateUrl = CONFIG.requestName + this.$apiOpt.getShedRecommendation;
      this.$apiUtils
        .get(rateUrl, {
          customerId: this.customerId,
          shedName: shed.shedName,
        })
        .then((data) => {
          let avgValue_ = 0;
          data &&
            data.forEach((x, index) => {
              let { date, syncRate } = x;

              if (date && date.indexOf(" ") != -1) {
                date = date.split(" ")[0];
              }
              if (syncRate == "-" || !syncRate) {
                syncRate = 0;
              } else {
                avgValue_ = syncRate * 1 + avgValue_;
              }
              this.pmData.xData.push(date);
              this.pmData.y1Data.push(syncRate * 1);
            });
          if (data && Array.isArray(data)) {
            if (data.length > 0) {
              this.showKeyDialog = true;
              this.syncRate = (avgValue_ / data.length).toFixed(2);
              let options = getOpt(this.pmData);
              unwarp(this.chart).setOption(options);
              this.recommendation = data[0].recommendation;
            } else {
              this.showKeyDialog = false;
            }
          } else {
            this.showKeyDialog = false;
          }
        });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.reload();
  },
  beforeRouteEnter(to, from) {
    /*if (dutyLightWallRender) {
      dutyLightWallRender(false);
    }
    if (unorganizedLightWallRender) {
      unorganizedLightWallRender(true, "forceUpdate");
    }*/
    CamLeapFunc();
  },
  beforeRouteLeave(to, from, next) {
    this.$nextTick(() => { // 处理无组织快速跳转首页，bringins-block遮罩层遮挡问题
      this.sourceShow = false;
      $(".unorganized-bg").hide();
      setTimeout(() => {
        $(".bringins-block").css('display') == 'block' ? $(".bringins-block").fadeOut(100) : '';
      }, 1000)
    })
    try {
      $(".bringins-block") && $(".bringins-block").length > 0
        ? $(".bringins-block").fadeOut(500)
        : "";
      if (next) {
        next();
      }
    } catch (err) {
      if (err) {
        console.log(err);
      }
    }
  },
};
</script>
<style scoped lang="scss">
.unorganized_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.unorganized-bg {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 11;
  display: none;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}
.KeyPointDialog {
  position: fixed;
  left: 2022px;
  top: 400px;
  width: 800px;
  height: 600px;
  background: rgba(27, 33, 45, 0.8);
  z-index: 1000000000000;
  .title {
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    color: white;
    span {
      display: block;
      float: left;
      padding: 10px 20px;
    }
    .chartTitle {
      width: 600px;
    }
    .rate {
      width: 100px;
      font-size: 28px;
      color: aquamarine;
      font-weight: 700;
      float: right;
      padding-right: 30px;
    }
  }
}
.chart {
  margin-top: 10px;
  width: 800px;
  height: 500px;
}
</style>
